import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useRef } from "react";
import Button from "../button";
import { job, jobDetails } from "../../utilities/careersData";
import CareerForm from "./form";
import { XMarkIcon } from "@heroicons/react/24/solid";

const Modal = ({ showModal, setShowModal, id }) => {
  let jobTitle = null;
  for (const iterator of job) {
    for (const iterator2 of iterator.jobs) {
      if (iterator2.id === id) {
        jobTitle = iterator2.label;
        break;
      }
    }
  }

  const ref = useRef(null);
  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setShowModal((prev) => !prev);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showModal, setShowModal]);

  const jobDetail = jobDetails.find((item) => item.jobId === id);
  if (!jobDetail) {
    return (
      <AnimatePresence>
        {showModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
            className="fixed top-0 z-20 flex h-screen w-screen items-center justify-center bg-slate-800 bg-opacity-75"
          >
            <div
              ref={ref}
              className="relative flex max-h-[87vh] min-h-[30rem] min-w-[90vw] max-w-[95vw] flex-col bg-white lg:min-w-[60vw]"
            >
              <div className="flex justify-between items-center border bg-slate-100 px-2 py-5 md:px-10">
                <h1 className="text-2xl text-visBlue md:text-4xl">
                  Job Title: No! Job Title Found
                </h1>
                <Button
                  onClick={() => setShowModal((prev) => !prev)}
                  backgroundColor="bg-transparent"
                  py="p-0"
                >
                  <XMarkIcon className="size-10 text-red-500" />
                </Button>
              </div>

              <div className="flex-grow flex h-full w-full items-center justify-center border-4">
                <h1 className="text-5xl">No! Data Found</h1>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    );
  }

  return (
    <AnimatePresence>
      {showModal && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
          className="fixed top-0 z-20 flex h-screen w-screen items-center justify-center bg-slate-800 bg-opacity-75"
        >
          <div
            ref={ref}
            className="relative flex max-h-[87vh] min-h-[30rem] min-w-[90vw] max-w-[95vw] flex-col bg-white lg:min-w-[60vw]"
          >
            <div className="flex justify-between border bg-slate-100 px-2 py-5 md:px-10">
              <h1 className="text-2xl text-visBlue md:text-4xl">
                Job Title: {jobTitle}
              </h1>
              <Button
                onClick={() => setShowModal((prev) => !prev)}
                backgroundColor="bg-transparent"
                py=""
              >
                <XMarkIcon className="size-10 text-red-500" />
              </Button>
            </div>
            <div className="flex-grow space-y-10 overflow-y-auto px-2 py-5 md:px-10">
              <div className="space-y-1">
                <h1 className="text-3xl text-visBlue">Job Description:</h1>
                <p>{jobDetail.discription}</p>
              </div>
              <div className="space-y-1">
                <h1 className="mb-1 text-3xl text-visBlue">Requirements:</h1>
                <ol className="list-inside list-disc">
                  {jobDetail.requirements.map((desc) => {
                    return (
                      <>
                        <li>{desc}</li>
                      </>
                    );
                  })}
                </ol>
              </div>

              <CareerForm setShowModal={setShowModal} />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Modal;
